import request from '../utils/axios'

const getAppId = async () => {
  return await request.get('/app_id')
}

const login = async (code) => {
  return await request.get(`/login?code=${code}`)
}

const getURL = async () => {
  return await request.get(`/user/auth_url`)
}
const userInfo = async () => {
  return await request.get('/user_info')
}
export { getAppId, login, getURL,userInfo }
